(function(){
  function money(c){return '€' + (c/100).toFixed(2).replace('.', ',');}
  function setup(root){
    if(root.dataset.msProductInit==='1') return;
    root.dataset.msProductInit='1';
    var json=root.querySelector('[data-ms-variants]');
    if(!json) return;
    var variants=JSON.parse(json.textContent);
    var idInput=root.querySelector('[data-ms-variant-id]');
    var selected=[];
    root.querySelectorAll('.ms-product__option').forEach(function(fs,i){
      var p=fs.querySelector('[aria-pressed="true"]');
      selected[i]=p?p.dataset.value:null;
    });
    function find(){
      return variants.find(function(v){return v.options.every(function(o,i){return o===selected[i];});});
    }
    function markAvailability(){
      root.querySelectorAll('[data-ms-option]').forEach(function(b){
        var idx=+b.dataset.msOption;
        var ok=variants.some(function(v){
          return v.available && v.options.every(function(o,i){return i===idx?o===b.dataset.value:o===selected[i];});
        });
        b.classList.toggle('is-unavailable',!ok);
      });
    }
    function update(){
      var v=find();
      var buy=root.querySelector('[data-ms-buy]');
      if(!v){ if(buy){buy.disabled=true;buy.querySelector('span').textContent='NIJE DOSTUPNO';} return; }
      if(idInput){ idInput.value=v.id; idInput.dispatchEvent(new Event('change',{bubbles:true})); }
      root.querySelector('[data-ms-current]').textContent=money(v.price);
      var cmp=root.querySelector('[data-ms-compare]'), sale=root.querySelector('[data-ms-sale]');
      if(v.compare_at_price && v.compare_at_price>v.price){
        cmp.textContent=money(v.compare_at_price); cmp.hidden=false;
        sale.textContent='-'+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'; sale.hidden=false;
      } else { cmp.hidden=true; sale.hidden=true; }
      if(buy){ buy.disabled=!v.available; buy.querySelector('span').textContent=v.available?'KUPI ODMAH':'RASPRODATO'; }
      if(v.featured_media){
        var t=root.querySelector('[data-ms-thumb][data-media-id="'+v.featured_media.id+'"]');
        if(t) t.click();
      }
      try{ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u); }catch(e){}
      markAvailability();
    }
    root.querySelectorAll('[data-ms-option]').forEach(function(b){
      b.addEventListener('click',function(){
        var idx=+b.dataset.msOption;
        selected[idx]=b.dataset.value;
        root.querySelectorAll('[data-ms-option="'+idx+'"]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b));});
        var lbl=root.querySelector('[data-ms-option-label="'+idx+'"]'); if(lbl) lbl.textContent=b.dataset.value;
        update();
      });
    });
    markAvailability();
  }
  function init(){document.querySelectorAll('[data-ms-product]').forEach(setup);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
